import { useState, useCallback, useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import { getFeature } from '../../DaEditorWrapper/Features/helper';
import { IS_EMPTY_FEATURE } from '../../DaEditorWrapper/Features';
import { isAndroid } from '../../utils/browser';
var useEditor = function (_a) {
    var _b = _a === void 0 ? {} : _a, onEditorReady = _b.onEditorReady, onEditorInitialContentReady = _b.onEditorInitialContentReady, onEditorChange = _b.onEditorChange, onFocus = _b.onFocus, onBlur = _b.onBlur, autoFocus = _b.autoFocus;
    var _c = useState(null), editorApi = _c[0], setEditorApi = _c[1];
    var _d = useState(null), editorState = _d[0], setEditorState = _d[1];
    var _e = useState(null), editorToolbars = _e[0], setEditorToolbars = _e[1];
    var handleEditorReady = useCallback(function (toolbars, api) {
        setEditorToolbars(toolbars);
        setEditorApi(api);
        onEditorReady && onEditorReady(toolbars, api);
        if (autoFocus && typeof window !== 'undefined') {
            window.requestAnimationFrame(function () {
                api.focusEditor();
            });
        }
    }, [autoFocus, onEditorReady]);
    var handleEditorChange = useCallback(function (rawContentState, editorContent, features) {
        // When adding new entities, the change might not be reflected on `editorContent`, so to be safe we make a
        // deep comparison on the `rawContentState`.
        // Comparing `editorContent` is still useful because it's faster and will short circuit in many cases before
        // we get to the isEqual call.
        var contentChanged = !editorState ||
            !editorState.editorContent.equals(editorContent) ||
            !isEqual(editorState.rawContentState, rawContentState);
        var newState;
        if (contentChanged) {
            var isEmpty = getFeature(IS_EMPTY_FEATURE, features).data.isEmpty;
            newState = {
                rawContentState: rawContentState,
                editorContent: editorContent,
                features: features,
                isEmpty: isAndroid() ? false : isEmpty,
            };
            setEditorState(newState);
        }
        onEditorChange && onEditorChange(newState || editorState);
    }, [editorState, onEditorChange]);
    var handleOverrideEditor = useCallback(function (newEditorState) {
        setEditorState(newEditorState);
    }, []);
    var editorProps = useMemo(function () {
        return ({
            onEditorInit: handleEditorReady,
            onContentChange: handleEditorChange,
            onInitialContentReady: onEditorInitialContentReady,
            onFocus: onFocus,
            onBlur: onBlur,
        });
    }, [
        handleEditorReady,
        handleEditorChange,
        onEditorInitialContentReady,
        onFocus,
        onBlur,
    ]);
    return {
        editorApi: editorApi,
        editorState: editorState,
        editorToolbars: editorToolbars,
        editorProps: editorProps,
        /**
         * In rare cases, we may need to override the editor state completely.
         *
         * Currently, the only one we need to do that for is our fallback editors.
         */
        overrideEditorState: handleOverrideEditor,
    };
};
export default useEditor;
//# sourceMappingURL=useEditor.js.map